export default "__VITE_ASSET__Be9lP0cN__"